module.exports = __webpack_public_path__ + "media/brands/jelcz-71929a1f.png";